export default {"src":"/_next/static/media/video-session.6b972ed6.svg","height":57,"width":60,"blurWidth":0,"blurHeight":0};